<script>
export default {
  name: 'Tab',
  props: ['text','route', 'customWidth'],
  computed: {
    cssItemWidth(){
      if (!isNaN(parseInt(this.customWidth, 10))){
        return "width: " + this.customWidth + "px;"
      } else {
        return "width: 200px;" // Largeur par défaut
      }
    },
  }
}
</script>


<template>
  <router-link class="link" :to= route :style="cssItemWidth">
    <div class="tab"> {{text}} </div>
  </router-link>
</template>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../assets/main.scss';

.link{
  @include myFont;
  letter-spacing: 0.5px;
  font-weight: 600;
  font-size: 18px;
  color: $black;
  // width: 120px;
  border-bottom: 2px solid $black-light;
  text-align: center;
  padding: 0 0 3px 0;
  
  &:hover{
    color: $main;
    border-bottom: 2px solid $main;
  }

  &.router-link-active{
    border-bottom: 2px solid $main;
    color: $main;
  }
}

</style>
